// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"580d8c33","633":"ff304b8b"}[chunkId] + ".chunk.js";
};